// PGCET MCA Mock 4 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "The preorder traversal of a Binary Search Tree is 30, 20, 10, 25, 40, 35, 50. Its postorder traversal is",
    options: [
      "A. 10, 25, 20, 35, 50, 40, 30",
      "B. 10, 20, 25, 30, 35, 40, 50",
      "C. 25, 10, 20, 50, 35, 40, 30",
      "D. 10, 25, 35, 50, 20, 40, 30"
    ],
    answer: "A"
  },
  {
    id: 32,
    question: "The value of the postfix expression 6 2 3 + − 3 8 2 / + * is",
    options: ["A. 49", "B. 7", "C. 1", "D. 14"],
    answer: "B"
  },
  {
    id: 33,
    question: "The keys 12, 18, 13, 2, 3, 23, 5, 15 are inserted in that order into an initially empty hash table of size 10 using h(k) = k mod 10 and linear probing. In which slot does the key 15 end up?",
    options: ["A. 5", "B. 0", "C. 9", "D. 7"],
    answer: "C"
  },
  {
    id: 34,
    question: "The time complexity of building a binary heap from n unsorted elements using the bottom-up heapify method is",
    options: ["A. O(n log n)", "B. O(log n)", "C. O(n²)", "D. O(n)"],
    answer: "D"
  },
  {
    id: 35,
    question: "The solution of the recurrence T(n) = 4T(n/2) + n² is",
    options: ["A. Θ(n²)", "B. Θ(n² log n)", "C. Θ(n³)", "D. Θ(n log n)"],
    answer: "B"
  },
  {
    id: 36,
    question: `What is printed by the following C code?
      int f(int n) { return n <= 1 ? 1 : n * f(n - 2); }
      printf("%d", f(7));`,
    options: ["A. 5040", "B. 35", "C. 105", "D. 15"],
    answer: "C"
  },
  {
    id: 37,
    question: `What is printed by the following C code?
      int i, s = 0;
      for (i = 1; i <= 10; i++) {
        if (i % 3 == 0) continue;
        if (i == 8) break;
        s += i;
      }
      printf("%d", s);`,
    options: ["A. 19", "B. 27", "C. 28", "D. 36"],
    answer: "A"
  },
  {
    id: 38,
    question: "The Emp table has salaries 5000, 7000, 7000, 3000, 9000 and 9000. What does SELECT MAX(salary) FROM Emp WHERE salary < (SELECT MAX(salary) FROM Emp); return?",
    options: ["A. 9000", "B. 5000", "C. 7000", "D. NULL"],
    answer: "C"
  },
  {
    id: 39,
    question: "Relation R(A, B, C, D) has the functional dependencies AB → C, C → D and D → A. The highest normal form R satisfies is",
    options: ["A. 1NF", "B. 2NF", "C. BCNF", "D. 3NF"],
    answer: "D"
  },
  {
    id: 40,
    question: "Consider the schedule S: r₁(X), r₂(X), w₁(X), w₂(X), where rᵢ and wᵢ are the read and write of transaction Tᵢ. Which statement about S is correct?",
    options: [
      "A. S is not conflict serializable and suffers from the lost update problem",
      "B. S is conflict serializable and equivalent to T₁ followed by T₂",
      "C. S is conflict serializable and equivalent to T₂ followed by T₁",
      "D. S is a serial schedule"
    ],
    answer: "A"
  },
  {
    id: 41,
    question: "A host has the IP address 192.168.10.77/27. The broadcast address of its subnet is",
    options: ["A. 192.168.10.63", "B. 192.168.10.95", "C. 192.168.10.127", "D. 192.168.10.255"],
    answer: "B"
  },
  {
    id: 42,
    question: "Which of the following protocol – default port pairs is INCORRECT?",
    options: ["A. HTTPS – 443", "B. SMTP – 25", "C. DNS – 53", "D. FTP (control) – 22"],
    answer: "D"
  },
  {
    id: 43,
    question: "In a 10 Mbps CSMA/CD network the maximum round-trip propagation delay is 51.2 μs. The minimum frame size needed to detect collisions is",
    options: ["A. 32 bytes", "B. 512 bytes", "C. 64 bytes", "D. 128 bytes"],
    answer: "C"
  },
  {
    id: 44,
    question: "The 8-bit two's complement representation of −45 is",
    options: ["A. 11010010", "B. 11010011", "C. 10101101", "D. 01010011"],
    answer: "B"
  },
  {
    id: 45,
    question: "The value of (235)₈ + (10110)₂ in decimal is",
    options: ["A. 179", "B. 181", "C. 169", "D. 257"],
    answer: "A"
  },
  {
    id: 46,
    question: "Processes P1, P2, P3, P4 arrive at times 0, 1, 2, 3 with CPU bursts 8, 4, 9, 5 respectively. Using preemptive Shortest Remaining Time First scheduling, the average waiting time is",
    options: ["A. 7.75", "B. 5.75", "C. 8.5", "D. 6.5"],
    answer: "D"
  },
  {
    id: 47,
    question: "A counting semaphore is initialised to 7. Then 20 P (wait) and 15 V (signal) operations are performed on it. Its final value is",
    options: ["A. 2", "B. 12", "C. −2", "D. 0"],
    answer: "A"
  },
  {
    id: 48,
    question: "A system uses 32-bit logical addresses, a page size of 4 KB and 4-byte page table entries. The size of a single-level page table per process is",
    options: ["A. 1 MB", "B. 4 MB", "C. 4 KB", "D. 2 MB"],
    answer: "B"
  },
  {
    id: 49,
    question: "Using LRU page replacement with 3 frames (initially empty), how many page faults occur for the reference string 7, 0, 1, 2, 0, 3, 0, 4, 2, 3, 0, 3, 2?",
    options: ["A. 8", "B. 10", "C. 9", "D. 11"],
    answer: "C"
  },
  {
    id: 50,
    question: "A 2-way set-associative cache has 64 blocks. Main memory block number 200 maps to set number",
    options: ["A. 40", "B. 4", "C. 16", "D. 8"],
    answer: "D"
  },
  {
    id: 51,
    question: `What is printed by the following Java code?
      class A { void show() { System.out.print("A"); } }
      class B extends A { void show() { System.out.print("B"); } }
      A obj = new B(); obj.show();`,
    options: ["A. A", "B. AB", "C. B", "D. Compilation error"],
    answer: "C"
  },
  {
    id: 52,
    question: "Which of the following operators cannot be overloaded in C++?",
    options: ["A. :: (scope resolution)", "B. +", "C. []", "D. ()"],
    answer: "A"
  },
  {
    id: 53,
    question: "A program's control flow graph has 12 edges, 10 nodes and 1 connected component. Its cyclomatic complexity is",
    options: ["A. 2", "B. 4", "C. 3", "D. 22"],
    answer: "B"
  },
  {
    id: 54,
    question: "The minimum number of 2-input NAND gates required to implement a 2-input XOR gate is",
    options: ["A. 3", "B. 5", "C. 4", "D. 6"],
    answer: "C"
  },
  {
    id: 55,
    question: "The minimum number of flip-flops needed to build a counter that counts from 0 to 99 (mod-100) is",
    options: ["A. 6", "B. 10", "C. 100", "D. 7"],
    answer: "D"
  }
];

export default pgcetmcaComputerAwareness;
